module.exports = __webpack_public_path__ + "img/161_thumbnail.5923e61c.jpg";